export default __webpack_public_path__ + "static/media/021-divorce.4b8f6199.png";